import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp, XIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { SpanView } from '@/routes/(app)/(tracing)/components/tree-span-view';
import { TraceContext } from '@/routes/(app)/(tracing)/context/trace-context';

export const TraceDetails = () => {
  const { trace, currentTraceIndex, prevTrace, nextTrace, traces, clearData } =
    useContext(TraceContext);
  const { t } = useTranslation();

  const handlePrevTrace = useCallback(() => {
    prevTrace();
  }, [prevTrace]);

  const handleNextTrace = useCallback(() => {
    nextTrace();
  }, [nextTrace]);

  const handleClearData = useCallback(() => {
    clearData();
  }, [clearData]);

  return (
    <ScrollArea className='m-2 h-full'>
      <div className='flex items-center gap-4'>
        <h2 className='text-2xl font-semibold'>
          {t('tracing.traceDetails.amountOfSpans_one', {
            count: trace?.length ?? 0,
          })}
        </h2>
        <Button
          size={'sm'}
          variant={'ghost'}
          onClick={handlePrevTrace}
          disabled={currentTraceIndex === 0}>
          <Button.Icon icon>
            <ChevronUp />
          </Button.Icon>
        </Button>
        <Button
          size={'sm'}
          variant={'ghost'}
          onClick={handleNextTrace}
          disabled={currentTraceIndex === traces.length - 1}>
          <Button.Icon icon>
            <ChevronDown />
          </Button.Icon>
        </Button>
        <Button
          size={'default'}
          onClick={handleClearData}
          variant={'outline'}
          className='ml-auto'>
          <Button.Icon icon>
            <XIcon />
          </Button.Icon>
        </Button>
      </div>
      <div className='p-6 px-1'> {trace && <SpanView trace={trace} />}</div>
    </ScrollArea>
  );
};
